'use client';

import type { LanguageSelect } from '@eliadmin/core/src/components/header/language-select';
import { deferOverlayComponent } from '@eliadmin/core/src/components/ui/dialog';

// The boundary must be client-side: a server dynamic import does not isolate the client graph.
// HeaderMain still decides whether this existing feature is enabled. The original widget is unchanged.
export const DeferredLanguageSelect = deferOverlayComponent<typeof LanguageSelect>(
  () => import('@eliadmin/core/src/components/header/language-select').then(module => module.LanguageSelect),
  'LanguageSelect',
);
